import styled, { css, RuleSet } from "styled-components";
import { darkGreen, lightGreyOutline, lightGreyText } from "../../../styles";
import { pulse } from "../../containers/styledComponents";
import { IconContainer } from "../styledComponents";

export const FilterContainer = styled.div<{
  isLoading: boolean;
  isInTable?: boolean;
  small?: boolean;
}>`
  /* Box Model */
  width: auto;
  max-width: 400px;
  height: 100%;
  max-height: ${({ isInTable }): string => (isInTable ? "1000px" : "53px")};
  min-height: 30px;
  padding: 5px;
  margin-left: ${({ isInTable, small }): string =>
    !isInTable && !small ? "12px" : "0px"};
  margin-right: 0px;

  /* Flexbox */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  /* Border */
  ${({ isInTable }): string | null =>
    !isInTable ? `border: 1px solid ${lightGreyOutline};` : null};
  border-radius: 7px;
  ${({ isInTable }): string | null =>
    !isInTable ? "box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.04);" : null};

  /* Background and Cursor */
  background-color: ${({ isInTable }): string | null =>
    isInTable ? "transparent" : "white"};
  cursor: pointer;

  /* Position */
  position: relative;

  /* Loading styles */
  background-color: ${({ isLoading, isInTable }): string =>
    isLoading ? "#D3D3D3" : isInTable ? "transparent" : "white"};
  ${({ isLoading }): false | RuleSet<object> =>
    isLoading &&
    css`
      animation: ${pulse} 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    `}
`;

// Styled button for the filter display
export const Filter = styled.button<{
  isDefaultColor: boolean;
  isInTable: boolean;
  small?: boolean;
}>`
  width: auto;
  height: 100%;
  padding: ${({ small }): string => (small ? "0 10px" : "10px")};
  font-family: "Apercu";
  background-color: transparent;
  text-align: left;
  border: none;
  color: ${({ isDefaultColor, isInTable }): string =>
    isDefaultColor || isInTable ? lightGreyText : darkGreen};
  cursor: pointer;
`;

// Dropdown list container
export const DropdownList = styled.div<{ small?: boolean }>`
  position: absolute;
  top: ${({ small }): string => (small ? "40px" : "65px")};
  width: auto;
  z-index: 1000;
  border-radius: 7px;
  border: 1px solid ${lightGreyOutline};
  background-color: white;
  margin-left: -5px;
  max-height: 50vh;
  overflow-y: auto;
`;

// Animated icon container for the dropdown arrow
export const AnimatedIconContainer = styled(IconContainer)<{
  isPointingDown: boolean;
}>`
  transition: transform 0.3s;
  transform: ${({ isPointingDown }): string =>
    isPointingDown ? "rotate(0deg)" : "rotate(180deg)"};
`;
